import { CpdBatchItemInput } from '../../graphql/private/PrivateSchemaTypes'
import { ActivityHistoryQuery } from './ActivityHistory.codegen'
import { TypeOfElement } from '../../../../types/generic'
import { DEFAULT_TABLE_FILTERS } from './activityHistoryConstants'
import { DateFilterType } from '../../components/common/dateFilter'

export enum ActivityHistoryTypeEnum {
  CPDManualEntryModel = 'CPDManualEntryModel',
  TopicEnrolmentModelAsStudent = 'TopicEnrolmentModelAsStudent',
  UserEventModel = 'UserEventModel'
}

export enum ActivityHistoryResourceSourceEnum {
  PathwayModelAsStudent = 'PathwayModelAsStudent',
  WorkspaceModelAsMember = 'WorkspaceModelAsMember',
  CertificationModelAsStudent = 'CertificationModelAsStudent'
}

export interface ActivityHistoryDateFiltersState {
  dateFilters: DateFilterType
  setDateFilters: (update: DateFilterType) => void
}

export type ActivityHistoryRowType = TypeOfElement<
  ActivityHistoryQuery['me']['activityHistory']['items']
>

export type ActivityHistoryTableFilters = typeof DEFAULT_TABLE_FILTERS

export interface CPDManualFormValues {
  activityName: string
  durationHours: number
  durationMinutes: number
  source: string
  dateStarted: string
  dateCompleted: string
  description: string
  attachment: null | File
}

export interface CPDManualFormValuesWithId extends CPDManualFormValues {
  id: number
  fileName: string
}

export type CPDSelectedItem = Omit<CpdBatchItemInput, 'isCpd'>

export interface ActivityTableSelectionState {
  items: CPDSelectedItem[]
  ids: number[]
}
